import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-approval',
    templateUrl: './approval.component.html',
    styleUrls: ['./approval.component.css']
})
export class ApprovalComponent implements OnInit {

    uploadedSignedContract = false;
    uploadedVoidedCheck = false;
    uploadedFrontDL = false;
    uploadedBackDL = false;

    errorTitle = '';
    errorId = 'AppE';
    errorMessageA = '';
    errorMessageB = '';
    errorMessageC = '';
    errorMessageBClass = '';

    applicationId: number;

    constructor(private connectionService: ConnectionService, private router: Router) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.applicationId = navigation.extras.state.applicationId;
        } else {
            this.router.navigateByUrl('/');
        }
    }

    ngOnInit(): void {
        void (0);
    }

    onSignedContractAdded(event: any) {
        this.uploadDocument({
            documentB: event.file.data.substr(event.file.data.indexOf(',') + 1), name: event.file.name
        }, 'contract').then(() => { this.uploadedSignedContract = true; });
    }

    onVoidedCheckAdded(event: any) {
        this.uploadDocument({
            documentB: event.file.data.substr(event.file.data.indexOf(',') + 1), name: event.file.name
        }, 'voided_check').then(() => { this.uploadedVoidedCheck = true; });
    }

    onFrontDLAdded(event: any) {
        this.uploadDocument({
            documentB: event.file.data.substr(event.file.data.indexOf(',') + 1), name: event.file.name
        }, 'dl_front').then(() => { this.uploadedFrontDL = true; });
    }

    onBackDLAdded(event: any) {
        this.uploadDocument({
            documentB: event.file.data.substr(event.file.data.indexOf(',') + 1), name: event.file.name
        }, 'dl_back').then(() => { this.uploadedBackDL = true; });
    }

    onSignedContractClick() {
        $('#dragDropModal').modal();
    }

    uploadDocument(document: any, documentType: string) {
        return new Promise((resolve, reject) => {
            this.connectionService.postCustomRequest(environment.gateway + 'uploadDocument/' + this.applicationId, document, 'application/json', 'document_type=' + documentType).subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    this.errorTitle = 'Sorry, we found a problem';
                    this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                    this.errorMessageB = error.error.msg;
                    this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                    this.errorMessageBClass = 'mB20';
                    $('#errorModalDialogAppE').modal();
                    reject(error.error);
                }
            );
        });
    }
}
